module.exports = __webpack_public_path__ + "static/img/nals-screens.285084f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/nals/nals-screens.jpg
// module id = qISU
// module chunks = 0